import { render, staticRenderFns } from "./AccessLisence.vue?vue&type=template&id=15761193"
import script from "./AccessLisence.vue?vue&type=script&lang=js"
export * from "./AccessLisence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports